/** USD input: optional dollar sign, correctly grouped commas, at most two cents digits.
 * Keep the original text in drafts; parse only when validating or reading it.
 */
export function parseMoney(text: string): number | undefined {
  const trimmed = text.trim();

  if (!/^\$?\s*(?:\d+|\d{1,3}(?:,\d{3})+)(?:\.\d{1,2})?$/.test(trimmed)) {
    return undefined;
  }

  const amount = Number(trimmed.replace(/[$,\s]/g, ""));
  return Number.isFinite(amount) && amount <= Number.MAX_SAFE_INTEGER / 100
    ? amount
    : undefined;
}

const usd = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
});

export function formatMoneyAnswer(text: string): string {
  const amount = parseMoney(text);
  return amount === undefined ? text : usd.format(amount);
}
